import { OrderPayment } from '@shared/payment'
import { i18WithDefault as t } from '@shared/locales'
import { CustomOrderAdminDto, CustomOrderClientDto } from 'service-api/src/types/api'

type OrderType = CustomOrderAdminDto | CustomOrderClientDto

export const sumDepositCharges = (deposits: OrderPayment[] = []) =>
  deposits.reduce(
    (acc, deposit) =>
      acc +
      (deposit.transactions ?? [])
        .filter((t) => t.type === 'CHARGE')
        .reduce((sum, t) => sum + (t.amount ?? 0) + (t.surcharge ?? 0) + (t.surchargeTax ?? 0), 0),
    0
  )

export const getDepositLabel = (order: OrderType): string => {
  const payments = order.payments || []
  const activePayments = payments.filter((p) => p.step !== 'CANCELED')

  for (const payment of activePayments) {
    const transactions = (payment as { transactions?: { originType?: string | null }[] }).transactions || []
    for (const txn of transactions) {
      if (txn.originType === 'CUSTOM') return t('depositPolicy.label.custom')
      if (txn.originType === 'SEASONAL') return t('depositPolicy.label.seasonal')
    }
  }

  return ''
}
